

const association_key = getURLParameter("key");
const interpreter_code = getURLParameter("interpreter_code");
const booking_id = getURLParameter("booking_id");

$(document).ready(function () {

    // Only for Report Booking Page
    if (!$('#interpreter_report_booking_page').length) return false;

    if (association_key === null || interpreter_code === null || booking_id === null) {
        displayUnauthorizedPage();
        return;
    }
    
    // Retrieve related booking and check if all checksum validations are OK
    retrieveBooking(booking_id, interpreter_code, association_key);

    // Trigger the Issues options
    $('input[name="issue"]').on("change", manageIssuesToggle);

    $("#isMultiDay").on("change", manageMultiDay);


    $("#jobReportForm").on("submit", submitReportForm);

    $("#finishingTimeOnly").timepicker({ timeFormat: "hh:mm tt", controlType: "select", oneLine: true, showButtonPanel: true, showTime: false, currentText: "" });


    function retrieveBooking(bookingId, interpreterCode, associationKey) {
        $.ajax({
            type: "GET",
            url: getApiURL("interpreters/report/booking/") + bookingId + '/' + interpreterCode + '/' + associationKey,
            success: function (data) {
                $("[data-start").text(moment(data.datetime).format('hh:mm A'));
                $("[data-duration").text(data.duration);
                $("#finishingTimeOnly").val(moment(data.finishing_time).format('hh:mm A'));
                $("#finishingDate").val(moment(data.finishing_time).format('YYYY-MM-DD'));
                $("#bookingDate").val(moment(data.datetime).format('YYYY-MM-DD'));
                $("[data-ref]").text(data.ref);
                return data;
            },
            error: function (request) {
                switch (request.status) {
                    case 401: displayAlreadyReported(ATLAlerts.formatAPIException(request), "No Report Available"); break;
                    case 404: displayNotFound(ATLAlerts.formatAPIException(request), "No Booking Found"); break;
                    case 500: displayTechnical(); break;
                    default: displayUnauthorizedPage();
                }
                return null;
            }
        });
    }

    function manageIssuesToggle() {
        if ($(this).val() === "running_late") {
            $("#lateDetailsContainer").slideDown(200);
        } else {
            $("#lateDetailsContainer").slideUp(200, function () {
                $("#delayHours").val("");
                $("#delayMinutes").val("");
            });
        }
    }

    function manageMultiDay() {
        const isChecked = $(this).is(":checked");
        const $comments = $("#jobComments");
        const $commentsRequired = $("#commentsRequired");

        if (isChecked) {
            $("#finishingTimeGroup, #issuesGroup").slideUp(200);
            $comments.attr("placeholder", "Since this is a multi-day assignment, please only fill in the end date and time on your final day, and any other comment here");
            $commentsRequired.show();
        } else {
            $("#finishingTimeGroup, #issuesGroup").slideDown(200);
            $comments.attr("placeholder", "Provide any additional comments or observations here...");
            $commentsRequired.hide();
        }
    }

    function submitReportForm(e) {
        e.preventDefault();

        const timeVal = $("#finishingTimeOnly").val();
        const finishingDate = $("#bookingDate").val();
        const isAcknowledged = $("#legalAcknowledgment").is(":checked");
        const selectedIssue = $('input[name="issue"]:checked').val();
        const $delayHours = $("#delayHours");
        const $delayMinutes = $("#delayMinutes");
        const hrs = $delayHours.val();
        const mins = $delayMinutes.val();
        const $submitBtn = $("#jobReportForm").find('button[type="submit"]');
        const isMultiDay = $("#isMultiDay").is(":checked");
        const commentsVal = $("#jobComments").val().trim();

        let formattedFinishingMoment;
        if (!isMultiDay) {
            if (!timeVal) {
                alert("Please select a finishing time.");
                return;
            }
            
            const finishingMoment = moment(`${finishingDate} ${timeVal}`, "YYYY-MM-DD hh:mm a");
            formattedFinishingMoment = finishingMoment.format("DD/MM/YYYY @ h:mm a");
            if (finishingMoment.isAfter(moment())) {
                alert("The finishing time must be in the past. You entered: " + formattedFinishingMoment);
                return;
            }
        }

        if (!selectedIssue) {
            alert("Please select whether you encountered any issues.");
            return;
        }

        if (!isAcknowledged) {
            alert("Please acknowledge the legal statement before submitting.");
            return;
        }
        // Validation: Running late duration
        if (selectedIssue === "running_late" && !hrs && !mins) {
            alert("Please specify the hours or minutes you were running late.");
            return;
        }

        if (isMultiDay && !commentsVal) {
            alert("Please provide your finishing date, time, and any comments in the notes field.");
            return;
        }

        // Ask interpreter for confirmation
        if (!isMultiDay) {
            if (!confirm("You are about to complete your report. Do you confirm that your finishing time was " + formattedFinishingMoment)) {
                return;
            }
        } else {
            if (!confirm("You are about to complete your report for a multiple day booking. Do you confirm the final date and time below?\n" + $("#jobComments").val().trim())) {
                return;
            }
        }


        // Format delay string: "Xh Ym" or "Ym" if hours is 0/empty
        let formattedDelay = null;
        if (selectedIssue === "running_late") {
            const h = parseInt(hrs, 10) || 0;
            const m = parseInt(mins, 10) || 0;
            if (h > 0 && m > 0) {
            formattedDelay = `${h}h ${m}m`;
            } else if (h > 0) {
            formattedDelay = `${h}h`;
            } else {
            formattedDelay = `${m}m`;
            }
        }
        
        // Collected Data Payload
        const formData = {
            is_multi_day: isMultiDay,
            finishing_time: isMultiDay ? null : formattedFinishingMoment,
            comments: $("#jobComments").val().trim(),
            issue: selectedIssue,
            delay: formattedDelay,
            association_key: association_key,
            booking_id: booking_id,
            interpreter_code: interpreter_code,
            method: "finishing_time"
        };
        
        $.ajax({
            url: getApiURL("interpreters/report/booking"),
            type: "POST",
            dataType: 'json',
            data: formData,
            beforeSend: function() {
                $submitBtn.prop("disabled", true).text("Submitting...");
            },
            success: function () {
                $("#jobReportForm").slideUp(300, function () {
                    $("#successPanel").fadeIn(300);
                    $("#form-container").hide();
                });
            },
            error: function (xhr, status, error) {
                console.error("Submission failed", error);
                alert("Failed to submit the report. Please try again.");
            },
            complete: function() {
                $submitBtn.prop("disabled", false).text("Submit Report");
            }
        })
    }
});


